import { createFileRoute } from "@tanstack/react-router";

import { CoachWorkflowSchedulePage } from "src/pages/CoachWorkflowSchedulePage";

export const Route = createFileRoute(
  "/_auth/_coach/workflows/$workflowId/schedule",
)({
  component: RouteComponent,
  staticData: {
    getScrollRestoration: () => {
      return false;
    },
  },
});

function RouteComponent() {
  return <CoachWorkflowSchedulePage />;
}
